/* eslint-disable no-nested-ternary */
import React, { Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import { Popover, Spin, Table, Typography } from 'antd';
import Helpers from '@Apis/helpers';
import './style.scss';

const { Text } = Typography;

function MetricPinnedDailyRunRates({
  data, loading, tenantIds,
}) {
  const getTotalLog = (record) => {
    const val = (Number(record?.not_received_st_count) > 0 ? Math.log(Number(record?.not_received_st_count)) : 0) + (Number(record?.partially_received_st_count) > 0 ? Math.log(Number(record?.partially_received_st_count)) : 0);
    return val;
  };
  const columns = [
    {
      title: 'Tracking List',
      render: (text, record) => (
        <Fragment>
          <H3Text text={record?.list_name?.trim()?.length > 25 ? `${record?.list_name.trim()?.substring(0, 25)}..` : record?.list_name} className="" />
          <H3Text text={record?.tenant_name?.trim()?.length > 25 ? `${record?.tenant_name.trim()?.substring(0, 25)}..` : record?.tenant_name} className="table-subscript" />
        </Fragment>
      ),
    },
    {
      title: 'In Stock',
      render: (text, record) => <Text className="" type="success">{record?.inStock}</Text>,
    },
    {
      title: 'Running Low',
      render: (text, record) => <Text className="" type="warning">{record?.runningLow}</Text>,
    },
    {
      title: 'Out of Stock',
      render: (text, record) => <Text className="" type="danger">{record?.outOfStock}</Text>,
    },
  ];

  return (
    <div className="metric-inv__expiry_split__wrapper">
      {loading && (
        <div className="widget-loader">
          <Spin />
        </div>
      )}
      <div className="metric-inv__daily-run-rate">
        <H3Text text="Stock Tracker" className="metric-inv__expiry_split__title" />
        <div className="metric-inv__active-split-table">
          <Table
            showHeader
            size="small"
            scroll="scroll"
            columns={columns}
            dataSource={data || []}
            pagination={data?.length > 2 ? {
              pageSize: 3,
            } : false}
            onRow={(record) => ({
              className: 'table-row-pointer',
              onClick: () => {
                window.open(Helpers.appendSystemDefaultFilterIdInURL(`/inventory/manage?tab=/daily-run-rates&page=1&limit=10&tenant=${record?.tenant_id}&drr=${record?.drr_id}&list_name=${record?.list_name}&showDrr=true`), '_blank');
              },
            })}
          />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,

});

const mapDispatchToProps = (dispatch) => ({
});

MetricPinnedDailyRunRates.propTypes = {
  user: PropTypes.any,
  data: PropTypes.any,
  tenantIds: PropTypes.any,
  loading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MetricPinnedDailyRunRates));
